import React, { useEffect, useState } from 'react';
import StepItem from 'components/atoms/step_item';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProgress, progressAction } from 'store/modules/course_store/actions';
import Tour, { ReactourStep } from 'reactour';
import { ApplicationState } from 'store';
import { CourseState } from 'store/modules/course_store/types';
import getTitleForStep from 'components/atoms/get_title_for_step';
import createTrack from 'services/actions/tracker_actions';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

const CourseStage: React.FC = () => {
  const dispatch = useDispatch();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [steps, setSteps] = useState<ReactourStep[]>([]);

  const { course } = useSelector<ApplicationState, CourseState>((state) => state.session.course);
  const stepsCompleted = course?.steps_completed || [];
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    if (!course?.steps_completed?.length) {
      dispatch(getUserProgress());
    }
  }, [dispatch, course?.steps_completed]);

  const setTourSteps = (stepNumber: number) => {
    if (stepNumber === 1) {
      window.open('/curso');
    }

    const tourSteps: Record<number, ReactourStep[]> = {
      2: [
        {
          selector: '.find_biddings',
          content: (
            <div className="mt-1">
              <p>
                Em <strong>Encontrar Licitações</strong> você pode fazer pesquisas específicas,
                tendo à disposição diversos filtros para auxiliar na sua busca, visando obter
                resultados mais precisos.
              </p>
              <p>Para continuar o tutorial, clique em Encontrar Licitações, aqui à esquerda.</p>
            </div>
          ),
          position: 'left',
        },
      ],
      3: [
        {
          selector: '.market',
          content: (
            <div className="mt-1">
              <p>
                Em <strong>Análise de Mercado</strong> você tem acesso a vários dados e informações
                estratégicas para você planejar suas ações no mercado de licitações.
              </p>
              <p>Para continuar o tutorial, clique em Análise de Mercado, aqui à esquerda.</p>
            </div>
          ),
          position: 'right',
        },
      ],
      4: [
        {
          selector: '.manage_biddings',
          content: (
            <div className="mt-1">
              <p>
                Antes de te mostrar o <strong>Gerenciar Licitações</strong>, precisamos adicionar
                uma licitação à ferramenta. Para isso, vamos encontrar uma licitação.
              </p>
              <p>Clique em Encontrar Licitações, aqui à esquerda.</p>
            </div>
          ),
          position: 'right',
        },
      ],
    };

    setSteps(tourSteps[stepNumber] || []);
  };

  const handleClick = (stepNumber: number) => {
    dispatch(progressAction(stepNumber));
    createTrack(`IAML - Clicou na etapa ${stepNumber}`);
    setTourSteps(stepNumber);

    if (panel?.course_released && !stepsCompleted.includes(stepNumber)) {
      switch (stepNumber) {
        case 2:
          window.open('/banco_de_dados', '_self');
          break;
        case 3:
          window.open('/mercado', '_self');
          break;
        case 4:
          window.open('/minhas_licitacoes/management', '_self');
          break;
        default:
          window.open('/marcado', '_self');
      }
    } else {
      setIsTourOpen(true);
    }
  };

  return (
    <Container className="d-flex justify-content-between flex-column h-100">
      {[1, 2, 3, 4].map((step) => (
        <StepItem
          key={step}
          stepNumber={step}
          title={getTitleForStep(step)}
          actionText={
            stepsCompleted.includes(step)
              ? 'Rever'
              : panel?.course_released
              ? 'Continuar'
              : 'Iniciar'
          }
          onClick={() => handleClick(step)}
        />
      ))}
      <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        maskSpace={5}
        rounded={5}
      />
    </Container>
  );
};

export default CourseStage;
